import { Base, createApp } from '@studiometa/js-toolkit';
import { LargeText } from '@studiometa/ui';

/**
 * @typedef {{
 *   $children: {
 *     LargeText: LargeText[]
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * Config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    components: {
      LargeText,
    },
  };
}

export default createApp(App);
